// https://swiperjs.com/element
import { register as registerSwiper } from "swiper/element/bundle"

registerSwiper()
